<template>
  <v-container v-if="model" fluid>
    <v-alert
      :value="msg"
      type="error"
      dismissible
      transition="scale-transition"
      v-for="msg in message"
      :key="msg"
      >{{ msg }}</v-alert
    >
    <v-row>
      <v-col v-if="this.model">
        <v-card>
          <v-toolbar flat>
            <v-icon left color="accent">mdi-store</v-icon>
            <v-toolbar-title>Prescriptions</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn outlined to="/prescription" exact>
              <v-icon left>mdi-arrow-left</v-icon>Return to list
            </v-btn>
          </v-toolbar>
          <v-container fluid grid-list-xl>
            <prescription-form
              :prescription="this.model"
              v-on:update="update()"
            ></prescription-form>
          </v-container>
        </v-card>
      </v-col>
      <v-col cols="3">
        <v-card>
          <v-toolbar flat>
            <v-toolbar-title>Actions</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-row dense>
              <v-col>
                <duplicate :prescription="model" />
              </v-col>
            </v-row>
            <v-row dense>
              <v-col>
                <v-btn
                  outlined
                  :to="'/prescription/print/' + this.model.id"
                  exact
                >
                  <v-icon left>mdi-printer</v-icon>Print
                </v-btn>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col>
                <v-btn
                  outlined
                  @click="quoteAll"
                  :disabled="!this.model.isModifiable"
                >
                  <v-icon left>mdi-check</v-icon>Add all item to quote
                </v-btn>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col>
                <v-btn
                  outlined
                  color="success"
                  :href="`${REACT_URL()}/orders/` + this.model.orderId"
                  v-if="this.model.orderId"
                >
                  <v-icon left>mdi-clipboard-text</v-icon>
                  <span v-if="this.model.order.statusId != 'new'"
                    >View Order</span
                  >
                  <span v-else>View Quote</span>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col v-if="model">
        <wood-list
          :woods="this.model.woods"
          :prescriptionId="this.model.id"
          :catalogId="this.model.shop.catalog_id"
          :dominantHand="this.model.client.dominantHand"
          :prescription="this.model"
          v-on:update="update()"
          v-on:error="error($event)"
        ></wood-list>
      </v-col>
    </v-row>
    <v-row>
      <v-col v-if="model">
        <iron-list
          :irons="this.model.irons"
          :prescriptionId="this.model.id"
          :catalogId="this.model.shop.catalog_id"
          :shopId="this.model.shopId"
          :dominantHand="this.model.client.dominantHand"
          :prescription="this.model"
          v-on:update="update()"
          v-on:error="error($event)"
        ></iron-list>
      </v-col>
    </v-row>
    <v-row>
      <v-col v-if="model">
        <wedge-list
          :wedges="this.model.wedges"
          :prescriptionId="this.model.id"
          :catalogId="this.model.shop.catalog_id"
          :shopId="this.model.shopId"
          :dominantHand="this.model.client.dominantHand"
          :prescription="this.model"
          v-on:update="update()"
          v-on:error="error($event)"
        ></wedge-list>
      </v-col>
    </v-row>
    <v-row>
      <v-col v-if="model">
        <putter-list
          :putters="this.model.putters"
          :prescriptionId="this.model.id"
          :catalogId="this.model.shop.catalog_id"
          :shopId="this.model.shopId"
          :dominantHand="this.model.client.dominantHand"
          :prescription="this.model"
          v-on:update="update()"
          v-on:error="error($event)"
        ></putter-list>
      </v-col>
    </v-row>
  </v-container>
  <page-loading v-else />

</template>

<script>
import PrescriptionForm from "@components/prescriptions/PrescriptionForm.vue";

import WoodList from "@components/prescriptions/WoodList.vue";
import IronList from "@components/prescriptions/IronList.vue";
import WedgeList from "@components/prescriptions/WedgeList.vue";
import PutterList from "@components/prescriptions/PutterList.vue";
import Duplicate from "@components/prescriptions/Duplicate.vue";
import PageLoading from '../../components/PageLoading.vue';
import {REACT_URL} from "@/common/config-local";

export default {
  components: {
    PrescriptionForm,
    WoodList,
    IronList,
    WedgeList,
    PutterList,
    Duplicate,
    PageLoading,
  },
  data: function() {
    return {
      isModified: false,
      items: [],
      model: null,
      originalModel: null,
      datePicker: false,
      prescriptionId: null,
      message: null,
    };
  },
  mounted: function() {
    this.initialize();
  },
  watch: {
    $route() {
      this.initialize();
    },
  },
  methods: {
    REACT_URL() {
      return REACT_URL
    },
    initialize() {
      if (this.$route.params.id) {
        this.model = null;
        this.prescriptionId = this.$route.params.id;
        this.getPrescription(this.$route.params.id);
      } else {
        this.$route.push("/prescription");
      }
    },
    getPrescription(id) {
      this.$store
        .dispatch("prescriptions/get", {
          id: id,
        })
        .then((data) => (this.model = data));
    },
    update() {
      this.getPrescription(this.$route.params.id);
    },
    quoteAll() {
      this.loading = true;
      this.$store
        .dispatch("prescriptions/quoteAll", {
          id: this.prescriptionId,
        })
        .then(() => {
          this.initialize()
        })
        .finally(() => (this.loading = false));
    },
    error(payload) {
      this.message = [];
      for (const field in payload) {
        if ({}.propertyIsEnumerable.call(payload, field)) {
          const msg = payload[field];
          this.message.push(msg[0]);
        }
      }
    },
  },
};
</script>

<style lang="less" scoped></style>
